// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListItem-components-NotesModal-NotesButton-module__ActivityDot";
export { _1 as "ActivityDot" }
